"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = function _default(Froala) {
  Froala.RegisterShortcut(Froala.KEYCODE.SINGLE_QUOTE, 'quote', 'increase', "'");
  Froala.RegisterShortcut(Froala.KEYCODE.SINGLE_QUOTE, 'quote', 'decrease', "'", true);
  Froala.DefineIcon('quote', {
    NAME: 'quote-left',
    SVG_KEY: 'blockquote'
  });
  Froala.RegisterCommand('quote', {
    title: 'Quote',
    type: 'dropdown',
    html: function html() {
      var _this = this;

      var actions = {
        increase: 'Increase',
        decrease: 'Decrease'
      };
      var list = R.map(function (action) {
        return "\n          <li role=\"presentation\">\n              <a\n                class=\"fr-command fr-active ".concat(action, "\"\n                tabIndex=\"-1\"\n                role=\"option\"\n                data-cmd=\"quote\"\n                data-param1=\"").concat(action, "\"\n                title=\"").concat(actions[action], "\">\n                ").concat(_this.language.translate(actions[action]), "\n                <span class=\"fr-shortcut\">\n                  ").concat(_this.shortcuts.get("quote.".concat(action)), "\n                </span>\n              </a>\n            </li>\n          ");
      }, R.keys(actions));
      return "\n        <ul class=\"fr-dropdown-list\" role=\"presentation\">\n          ".concat(list.join(' '), "\n        </ul>\n      ");
    },
    focus: true,
    undo: true,
    callback: function callback(_cmd, action) {
      this.quote.apply(action);
    }
  });
};

exports.default = _default;